import { render, staticRenderFns } from "./ContainerInformeDescargas.vue?vue&type=template&id=7e3de4b7&"
import script from "./ContainerInformeDescargas.vue?vue&type=script&lang=ts&"
export * from "./ContainerInformeDescargas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports